import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { FormTemplate } from '../models/forms/form-template.model';
import { FormsService } from '../services/sections/job/forms.service';

@Injectable({
	providedIn: 'root'
})
export class FormsResolver implements Resolve<Observable<FormTemplate[]>> {

	constructor(
		private router: Router,
		private formsService: FormsService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.formsService
			.getFormTemplates(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
